import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema
export const certificationSchema = itemSchema.extend({
  name: z.string().max(50),
  issuer: z.string().max(50),
  date: z.string(),
  summary: z.string().max(100),
  url: urlSchema,
});

// Type
export type Certification = z.infer<typeof certificationSchema>;

export const defaultCertification: Certification = {
  ...defaultItem,
  name: "",
  issuer: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
